import React, { useState, useEffect } from "react";
import HistoryChart from "../HistoryChart";
import LoadingPlaceholder from "../../loading/LoadingPlaceholder";
import { fetchBudgetHistory } from "../../../../api/finances/budgetAPI";

const parseBudgetNumber = (value, fallback = 0) => {
  if (typeof value === "number")
    return Number.isFinite(value) ? value : fallback;
  if (typeof value !== "string") return fallback;

  const cleanedValue = value.trim().replace(/[^\d.,-]/g, "");
  if (!cleanedValue) return fallback;

  const hasComma = cleanedValue.includes(",");
  const hasDot = cleanedValue.includes(".");
  const commaParts = cleanedValue.split(",");
  const normalizedValue =
    hasComma && !hasDot && commaParts.length === 2 && commaParts[1].length < 3
      ? cleanedValue.replace(",", ".")
      : cleanedValue.replace(/,/g, "");
  const parsedValue = Number.parseFloat(normalizedValue);

  return Number.isFinite(parsedValue) ? parsedValue : fallback;
};

const normalizeThreshold = (value) => {
  const parsedThreshold = parseBudgetNumber(value, 0.85);

  return parsedThreshold > 1 ? parsedThreshold / 100 : parsedThreshold;
};

const BudgetHistoryChart = ({ budget, onSnapshotClick }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadHistory = async () => {
      setLoading(true);
      const result = await fetchBudgetHistory(budget.uuid);

      if (result.success) {
        setHistory(result.data);
      } else {
        setError(result.message);
      }
      setLoading(false);
    };

    if (budget?.uuid) {
      loadHistory();
    }
  }, [budget.uuid]);

  // Reference lines remain based on the current budget definition
  const limit = parseBudgetNumber(budget?.limit ?? budget?.amount_limit);
  const spent = parseBudgetNumber(budget?.spent ?? budget?.amount_spent);
  const threshold = normalizeThreshold(budget?.threshold);
  const thresholdValue = limit * threshold;

  const referenceLines = [
    { value: limit, label: "LIMIT", color: "#c70000" },
    {
      value: thresholdValue,
      label: `THR`,
      color: " #ADB0B2",
    },
  ];

  // Loading and Empty States
  if (loading) {
    return (
      <div style={{ padding: "10px", width: "100%" }}>
        <LoadingPlaceholder type="loading-card-large" rows={1} />
      </div>
    );
  }
  return (
    <div className="budget-history-section" style={{ marginTop: "20px" }}>
      <HistoryChart
        data={history} // history matches {label, value, status};
        referenceLines={referenceLines}
        height={220}
        emptyMsg="This budget is new. History will populate at the end of this cycle."
        onBarClick={onSnapshotClick}
        showXAxisLabels={false}
      />
    </div>
  );
};

export default BudgetHistoryChart;
